/* tslint:disable */
/* eslint-disable */
/**
 * OmronOpenAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';
import { DownloadHistoryParam} from 'features/download';

/**
 * 
 * @export
 * @interface Activation
 */
export interface Activation {
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'aId': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'productVersion': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'licenseModelName': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'activationDate': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'licenseKey': string;
    /**
     * 
     * @type {string}
     * @memberof Activation
     */
    'eId': string;
    /**
     * 
     * @type {boolean}
     * @memberof Activation
     */
    'isTrial': boolean;
}
/**
 * 
 * @export
 * @interface Entitlement
 */
export interface Entitlement {
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'pkId': string;
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'licenseModel': string;
    /**
     * 
     * @type {number}
     * @memberof Entitlement
     */
    'totalQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof Entitlement
     */
    'availableQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof Entitlement
     */
    'splittedQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof Entitlement
     */
    'usedQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof Entitlement
     */
    'creationDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof Entitlement
     */
    'isTrial': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Entitlement
     */
    'isNodeLocked': boolean;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GeneratePermissionTicketsResponse
 */
export interface GeneratePermissionTicketsResponse {
    /**
     * 
     * @type {string}
     * @memberof GeneratePermissionTicketsResponse
     */
    'permissionTicket': string;
}
/**
 * 
 * @export
 * @interface GetActivationsResponse
 */
export interface GetActivationsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetActivationsResponse
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof GetActivationsResponse
     */
    'pageIndex': number;
    /**
     * 
     * @type {number}
     * @memberof GetActivationsResponse
     */
    'maxPage': number;
    /**
     * 
     * @type {Array<Activation>}
     * @memberof GetActivationsResponse
     */
    'activations': Array<Activation>;
}
/**
 * 
 * @export
 * @interface GetDownloadResponse
 */
export interface GetDownloadResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDownloadResponse
     */
    'fileSize': string;
    /**
     * 
     * @type {string}
     * @memberof GetDownloadResponse
     */
    'downloadUrl': string;
}
/**
 * 
 * @export
 * @interface GetEntitlementsResponse
 */
export interface GetEntitlementsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetEntitlementsResponse
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof GetEntitlementsResponse
     */
    'pageIndex': number;
    /**
     * 
     * @type {number}
     * @memberof GetEntitlementsResponse
     */
    'maxPage': number;
    /**
     * 
     * @type {Array<Entitlement>}
     * @memberof GetEntitlementsResponse
     */
    'entitlements': Array<Entitlement>;
}
/**
 * 
 * @export
 * @interface GetProductsResponse
 */
export interface GetProductsResponse {
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetProductsResponse
     */
    'products': Array<Product>;
}
/**
 * 
 * @export
 * @interface GetProfileResponse
 */
export interface GetProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'familyNameFurigana': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'givenNameFurigana': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'companyFurigana': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'office': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'jobType': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'companyTel': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'companyFax': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'buildingName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProfileResponse
     */
    'market_status': boolean;
}
/**
 * 
 * @export
 * @interface GetSiteKeyResponse
 */
export interface GetSiteKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSiteKeyResponse
     */
    'siteKey': string;
}
/**
 * 
 * @export
 * @interface GetTrialResponse
 */
export interface GetTrialResponse {
    /**
     * 
     * @type {Array<TrialProduct>}
     * @memberof GetTrialResponse
     */
    'products': Array<TrialProduct>;
}
/**
 * 
 * @export
 * @interface GetUserResponse
 */
export interface GetUserResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    'orderCode': string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface PasswordRequest
 */
export interface PasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordRequest
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface PostActivateLicenseRequest
 */
export interface PostActivateLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof PostActivateLicenseRequest
     */
    'pkId': string;
    /**
     * 
     * @type {string}
     * @memberof PostActivateLicenseRequest
     */
    'fingerPrint': string;
    /**
     * 
     * @type {string}
     * @memberof PostActivateLicenseRequest
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface PostActivateLicenseResponse
 */
export interface PostActivateLicenseResponse {
    /**
     * 
     * @type {string}
     * @memberof PostActivateLicenseResponse
     */
    'licenseKey': string;
}
/**
 * 
 * @export
 * @interface PostActivateTrialLicenseRequest
 */
export interface PostActivateTrialLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof PostActivateTrialLicenseRequest
     */
    'pkId': string;
}
/**
 * 
 * @export
 * @interface PostActivateTrialLicenseResponse
 */
export interface PostActivateTrialLicenseResponse {
    /**
     * 
     * @type {string}
     * @memberof PostActivateTrialLicenseResponse
     */
    'licenseKey': string;
}
/**
 * 
 * @export
 * @interface PostEntitlementsRequest
 */
export interface PostEntitlementsRequest {
    /**
     * 
     * @type {string}
     * @memberof PostEntitlementsRequest
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof PostEntitlementsRequest
     */
    'featureId': string;
    /**
     * 
     * @type {string}
     * @memberof PostEntitlementsRequest
     */
    'licenseId': string;
}
/**
 * 
 * @export
 * @interface PostRevokeRequest
 */
export interface PostRevokeRequest {
    /**
     * 
     * @type {string}
     * @memberof PostRevokeRequest
     */
    'aId': string;
    /**
     * 
     * @type {string}
     * @memberof PostRevokeRequest
     */
    'revocationTicket': string;
}
/**
 * 
 * @export
 * @interface PostTransferLicenseRequest
 */
export interface PostTransferLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof PostTransferLicenseRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PostTransferLicenseRequest
     */
    'eId': string;
    /**
     * 
     * @type {string}
     * @memberof PostTransferLicenseRequest
     */
    'pkId': string;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'libVer': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'releaseDate': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'downloadId': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'fid': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'groupId': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'groupName': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'groupOrder': number;
}
/**
 * 
 * @export
 * @interface PutProfileRequest
 */
export interface PutProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'familyNameFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'givenNameFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'companyFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'office'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'jobType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'companyTel': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'companyFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutProfileRequest
     */
    'buildingName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PutProfileRequest
     */
    'market_status': boolean;
}
/**
 * 
 * @export
 * @interface ResetRequest
 */
export interface ResetRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ResetRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResetRequestRequest
 */
export interface ResetRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetRequestRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SignupRequest
 */
export interface SignupRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'familyNameFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'givenNameFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'companyFurigana'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'office'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'jobType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'companyTel': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'companyFax'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'buildingName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignupRequest
     */
    'market_status': boolean;
}
/**
 * 
 * @export
 * @interface TrialProduct
 */
export interface TrialProduct {
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'licensename': string;
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'fid': string;
    /**
     * 
     * @type {string}
     * @memberof TrialProduct
     */
    'lid': string;
}
/**
 * 
 * @export
 * @interface UpdateEntitlementRequest
 */
export interface UpdateEntitlementRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitlementRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitlementRequest
     */
    'eId': string;
}
/**
 * 
 * @export
 * @interface VerifyUserRequest
 */
export interface VerifyUserRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyUserRequest
     */
    'code': string;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PasswordRequest} passwordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        password: async (passwordRequest: PasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordRequest' is not null or undefined
            assertParamExists('password', 'passwordRequest', passwordRequest)
            const localVarPath = `/account/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reset: async (resetRequest: ResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetRequest' is not null or undefined
            assertParamExists('reset', 'resetRequest', resetRequest)
            const localVarPath = `/account/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {ResetRequestRequest} resetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRequest: async (resetRequestRequest: ResetRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetRequestRequest' is not null or undefined
            assertParamExists('resetRequest', 'resetRequestRequest', resetRequestRequest)
            const localVarPath = `/account/reset/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupRequest: SignupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupRequest' is not null or undefined
            assertParamExists('signup', 'signupRequest', signupRequest)
            const localVarPath = `/account/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {VerifyUserRequest} verifyUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser: async (verifyUserRequest: VerifyUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyUserRequest' is not null or undefined
            assertParamExists('verifyUser', 'verifyUserRequest', verifyUserRequest)
            const localVarPath = `/account/verify_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PasswordRequest} passwordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async password(passwordRequest: PasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.password(passwordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reset(resetRequest: ResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reset(resetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {ResetRequestRequest} resetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetRequest(resetRequestRequest: ResetRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetRequest(resetRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupRequest: SignupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {VerifyUserRequest} verifyUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUser(verifyUserRequest: VerifyUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUser(verifyUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): AxiosPromise<object> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<object> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PasswordRequest} passwordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        password(passwordRequest: PasswordRequest, options?: any): AxiosPromise<object> {
            return localVarFp.password(passwordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reset(resetRequest: ResetRequest, options?: any): AxiosPromise<object> {
            return localVarFp.reset(resetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {ResetRequestRequest} resetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRequest(resetRequestRequest: ResetRequestRequest, options?: any): AxiosPromise<object> {
            return localVarFp.resetRequest(resetRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupRequest: SignupRequest, options?: any): AxiosPromise<object> {
            return localVarFp.signup(signupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {VerifyUserRequest} verifyUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser(verifyUserRequest: VerifyUserRequest, options?: any): AxiosPromise<object> {
            return localVarFp.verifyUser(verifyUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public login(loginRequest: LoginRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public logout(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PasswordRequest} passwordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public password(passwordRequest: PasswordRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).password(passwordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ResetRequest} resetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public reset(resetRequest: ResetRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).reset(resetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {ResetRequestRequest} resetRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public resetRequest(resetRequestRequest: ResetRequestRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).resetRequest(resetRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public signup(signupRequest: SignupRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).signup(signupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {VerifyUserRequest} verifyUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public verifyUser(verifyUserRequest: VerifyUserRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).verifyUser(verifyUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActivationsApi - axios parameter creator
 * @export
 */
export const ActivationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {PostActivateLicenseRequest} postActivateLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense: async (postActivateLicenseRequest: PostActivateLicenseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postActivateLicenseRequest' is not null or undefined
            assertParamExists('activateLicense', 'postActivateLicenseRequest', postActivateLicenseRequest)
            const localVarPath = `/activations/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postActivateLicenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostActivateTrialLicenseRequest} postActivateTrialLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTrialLicense: async (postActivateTrialLicenseRequest: PostActivateTrialLicenseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postActivateTrialLicenseRequest' is not null or undefined
            assertParamExists('activateTrialLicense', 'postActivateTrialLicenseRequest', postActivateTrialLicenseRequest)
            const localVarPath = `/activations/trial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postActivateTrialLicenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} aId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePermissionTickets: async (aId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aId' is not null or undefined
            assertParamExists('generatePermissionTickets', 'aId', aId)
            const localVarPath = `/activations/permissionTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aId !== undefined) {
                localVarQueryParameter['aId'] = aId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivations: async (pageSize: number, pageIndex: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getActivations', 'pageSize', pageSize)
            // verify required parameter 'pageIndex' is not null or undefined
            assertParamExists('getActivations', 'pageIndex', pageIndex)
            const localVarPath = `/activations/activations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostRevokeRequest} postRevokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revoke: async (postRevokeRequest: PostRevokeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postRevokeRequest' is not null or undefined
            assertParamExists('revoke', 'postRevokeRequest', postRevokeRequest)
            const localVarPath = `/activations/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRevokeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivationsApi - functional programming interface
 * @export
 */
export const ActivationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {PostActivateLicenseRequest} postActivateLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateLicense(postActivateLicenseRequest: PostActivateLicenseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostActivateLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateLicense(postActivateLicenseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PostActivateTrialLicenseRequest} postActivateTrialLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateTrialLicense(postActivateTrialLicenseRequest: PostActivateTrialLicenseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostActivateTrialLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateTrialLicense(postActivateTrialLicenseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} aId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePermissionTickets(aId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratePermissionTicketsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePermissionTickets(aId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivations(pageSize: number, pageIndex: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivations(pageSize, pageIndex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PostRevokeRequest} postRevokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revoke(postRevokeRequest: PostRevokeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revoke(postRevokeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivationsApi - factory interface
 * @export
 */
export const ActivationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivationsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {PostActivateLicenseRequest} postActivateLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense(postActivateLicenseRequest: PostActivateLicenseRequest, options?: any): AxiosPromise<PostActivateLicenseResponse> {
            return localVarFp.activateLicense(postActivateLicenseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PostActivateTrialLicenseRequest} postActivateTrialLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTrialLicense(postActivateTrialLicenseRequest: PostActivateTrialLicenseRequest, options?: any): AxiosPromise<PostActivateTrialLicenseResponse> {
            return localVarFp.activateTrialLicense(postActivateTrialLicenseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} aId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePermissionTickets(aId: string, options?: any): AxiosPromise<GeneratePermissionTicketsResponse> {
            return localVarFp.generatePermissionTickets(aId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivations(pageSize: number, pageIndex: number, options?: any): AxiosPromise<GetActivationsResponse> {
            return localVarFp.getActivations(pageSize, pageIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PostRevokeRequest} postRevokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revoke(postRevokeRequest: PostRevokeRequest, options?: any): AxiosPromise<object> {
            return localVarFp.revoke(postRevokeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivationsApi - object-oriented interface
 * @export
 * @class ActivationsApi
 * @extends {BaseAPI}
 */
export class ActivationsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {PostActivateLicenseRequest} postActivateLicenseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationsApi
     */
    public activateLicense(postActivateLicenseRequest: PostActivateLicenseRequest, options?: AxiosRequestConfig) {
        return ActivationsApiFp(this.configuration).activateLicense(postActivateLicenseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PostActivateTrialLicenseRequest} postActivateTrialLicenseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationsApi
     */
    public activateTrialLicense(postActivateTrialLicenseRequest: PostActivateTrialLicenseRequest, options?: AxiosRequestConfig) {
        return ActivationsApiFp(this.configuration).activateTrialLicense(postActivateTrialLicenseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} aId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationsApi
     */
    public generatePermissionTickets(aId: string, options?: AxiosRequestConfig) {
        return ActivationsApiFp(this.configuration).generatePermissionTickets(aId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} pageSize 
     * @param {number} pageIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationsApi
     */
    public getActivations(pageSize: number, pageIndex: number, options?: AxiosRequestConfig) {
        return ActivationsApiFp(this.configuration).getActivations(pageSize, pageIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PostRevokeRequest} postRevokeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationsApi
     */
    public revoke(postRevokeRequest: PostRevokeRequest, options?: AxiosRequestConfig) {
        return ActivationsApiFp(this.configuration).revoke(postRevokeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConfigurationsApi - axios parameter creator
 * @export
 */
export const ConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecaptchaSiteKey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations/sitekey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationsApi - functional programming interface
 * @export
 */
export const ConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecaptchaSiteKey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSiteKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecaptchaSiteKey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigurationsApi - factory interface
 * @export
 */
export const ConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecaptchaSiteKey(options?: any): AxiosPromise<GetSiteKeyResponse> {
            return localVarFp.getRecaptchaSiteKey(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationsApi - object-oriented interface
 * @export
 * @class ConfigurationsApi
 * @extends {BaseAPI}
 */
export class ConfigurationsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    public getRecaptchaSiteKey(options?: AxiosRequestConfig) {
        return ConfigurationsApiFp(this.configuration).getRecaptchaSiteKey(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth(options?: any): AxiosPromise<void> {
            return localVarFp.checkHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkHealth(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkHealth(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadsApi - axios parameter creator
 * @export
 */
export const DownloadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
      /**
       *
       * @summary
       * @param {string} downloadId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getDownload: async (
        downloadId: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'downloadId' is not null or undefined
        assertParamExists("getDownload", "downloadId", downloadId);
        const localVarPath = `/downloads/download`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        if (downloadId !== undefined) {
          localVarQueryParameter["downloadId"] = downloadId;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * @summary function for build body parameters for api save history download
       * @param productId 
       * @param productName 
       * @param options 
       * @returns 
       */
      saveDownloadHistory: async (
        productId: string,
        productName: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameters
        assertParamExists(DownloadHistoryParam.SAVE_EXIST_DOWNLOAD, DownloadHistoryParam.PRODUCT_ID, productId);
        assertParamExists(DownloadHistoryParam.SAVE_EXIST_DOWNLOAD, DownloadHistoryParam.PRODUCT_NAME, productName);

        // API path
        const localVarPath = `/downloads/save-history`;

        // use dummy base URL (same as getDownload)
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);

        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };

        const localVarHeaderParameter = {
          "Content-Type": "application/json",
        } as any;   
        const localVarPostBody = {
            [DownloadHistoryParam.PRODUCT_ID]: productId,
            [DownloadHistoryParam.PRODUCT_NAME]: productName,
        };

        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        localVarRequestOptions.data = localVarPostBody;

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
};

/**
 * DownloadsApi - functional programming interface
 * @export
 */
export const DownloadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadsApiAxiosParamCreator(configuration)
    return {
      /**
       *
       * @summary
       * @param {string} downloadId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      async getDownload(
        downloadId: string,
        options?: AxiosRequestConfig
      ): Promise<
        (
          axios?: AxiosInstance,
          basePath?: string
        ) => AxiosPromise<GetDownloadResponse>
      > {
        const localVarAxiosArgs = await localVarAxiosParamCreator.getDownload(
          downloadId,
          options
        );
        return createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        );
      },
      /**
       * @summary function to create request for save download history
       * @param productId 
       * @param productName 
       * @param options 
       * @returns 
       */
      async saveHistoryDownload(
        productId: string,
        productName: string,
        options?: AxiosRequestConfig
      ): Promise<
        (
          axios?: AxiosInstance,
          basePath?: string
        ) => AxiosPromise<GetDownloadResponse>
      > {
        const localVarAxiosArgs =
          await localVarAxiosParamCreator.saveDownloadHistory(
            productId,
            productName,
            options
          );
        return createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        );
      },
    };
};

/**
 * DownloadsApi - factory interface
 * @export
 */
export const DownloadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} downloadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownload(downloadId: string, options?: any): AxiosPromise<GetDownloadResponse> {
            return localVarFp.getDownload(downloadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadsApi - object-oriented interface
 * @export
 * @class DownloadsApi
 * @extends {BaseAPI}
 */
export class DownloadsApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} downloadId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DownloadsApi
   */
  public getDownload(downloadId: string, options?: AxiosRequestConfig) {
    return DownloadsApiFp(this.configuration)
      .getDownload(downloadId, options)
      .then((request) => request(this.axios, this.basePath));
    }
    /**
     * @summary function to send request for call api save history download
     * @param productId 
     * @param productName 
     * @param options 
     * @returns {}
     */
  public saveHistoryDownload(  productId: string,productName: string, options?: AxiosRequestConfig) {
    return DownloadsApiFp(this.configuration)
      .saveHistoryDownload(productId,productName, options)
      .then((request) => request(this.axios, this.basePath));
  }
}



/**
 * EntitlementsApi - axios parameter creator
 * @export
 */
export const EntitlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {PostEntitlementsRequest} postEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialLicense: async (postEntitlementsRequest: PostEntitlementsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postEntitlementsRequest' is not null or undefined
            assertParamExists('createTrialLicense', 'postEntitlementsRequest', postEntitlementsRequest)
            const localVarPath = `/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postEntitlementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {string} searchText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements: async (pageSize: number, pageIndex: number, searchText: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getEntitlements', 'pageSize', pageSize)
            // verify required parameter 'pageIndex' is not null or undefined
            assertParamExists('getEntitlements', 'pageIndex', pageIndex)
            // verify required parameter 'searchText' is not null or undefined
            assertParamExists('getEntitlements', 'searchText', searchText)
            const localVarPath = `/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PostTransferLicenseRequest} postTransferLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferLicense: async (postTransferLicenseRequest: PostTransferLicenseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTransferLicenseRequest' is not null or undefined
            assertParamExists('transferLicense', 'postTransferLicenseRequest', postTransferLicenseRequest)
            const localVarPath = `/entitlements/transferLicense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTransferLicenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {UpdateEntitlementRequest} updateEntitlementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitlement: async (updateEntitlementRequest: UpdateEntitlementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEntitlementRequest' is not null or undefined
            assertParamExists('updateEntitlement', 'updateEntitlementRequest', updateEntitlementRequest)
            const localVarPath = `/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEntitlementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitlementsApi - functional programming interface
 * @export
 */
export const EntitlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {PostEntitlementsRequest} postEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrialLicense(postEntitlementsRequest: PostEntitlementsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrialLicense(postEntitlementsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {string} searchText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitlements(pageSize: number, pageIndex: number, searchText: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEntitlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitlements(pageSize, pageIndex, searchText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PostTransferLicenseRequest} postTransferLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferLicense(postTransferLicenseRequest: PostTransferLicenseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferLicense(postTransferLicenseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {UpdateEntitlementRequest} updateEntitlementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntitlement(updateEntitlementRequest: UpdateEntitlementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntitlement(updateEntitlementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntitlementsApi - factory interface
 * @export
 */
export const EntitlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitlementsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {PostEntitlementsRequest} postEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrialLicense(postEntitlementsRequest: PostEntitlementsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.createTrialLicense(postEntitlementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} pageSize 
         * @param {number} pageIndex 
         * @param {string} searchText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements(pageSize: number, pageIndex: number, searchText: string, options?: any): AxiosPromise<GetEntitlementsResponse> {
            return localVarFp.getEntitlements(pageSize, pageIndex, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PostTransferLicenseRequest} postTransferLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferLicense(postTransferLicenseRequest: PostTransferLicenseRequest, options?: any): AxiosPromise<object> {
            return localVarFp.transferLicense(postTransferLicenseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UpdateEntitlementRequest} updateEntitlementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitlement(updateEntitlementRequest: UpdateEntitlementRequest, options?: any): AxiosPromise<object> {
            return localVarFp.updateEntitlement(updateEntitlementRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntitlementsApi - object-oriented interface
 * @export
 * @class EntitlementsApi
 * @extends {BaseAPI}
 */
export class EntitlementsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {PostEntitlementsRequest} postEntitlementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    public createTrialLicense(postEntitlementsRequest: PostEntitlementsRequest, options?: AxiosRequestConfig) {
        return EntitlementsApiFp(this.configuration).createTrialLicense(postEntitlementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} pageSize 
     * @param {number} pageIndex 
     * @param {string} searchText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    public getEntitlements(pageSize: number, pageIndex: number, searchText: string, options?: AxiosRequestConfig) {
        return EntitlementsApiFp(this.configuration).getEntitlements(pageSize, pageIndex, searchText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PostTransferLicenseRequest} postTransferLicenseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    public transferLicense(postTransferLicenseRequest: PostTransferLicenseRequest, options?: AxiosRequestConfig) {
        return EntitlementsApiFp(this.configuration).transferLicense(postTransferLicenseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UpdateEntitlementRequest} updateEntitlementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    public updateEntitlement(updateEntitlementRequest: UpdateEntitlementRequest, options?: AxiosRequestConfig) {
        return EntitlementsApiFp(this.configuration).updateEntitlement(updateEntitlementRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any): AxiosPromise<GetProductsResponse> {
            return localVarFp.getProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrialsApi - axios parameter creator
 * @export
 */
export const TrialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrial: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrialsApi - functional programming interface
 * @export
 */
export const TrialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrial(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrial(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrialsApi - factory interface
 * @export
 */
export const TrialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrialsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrial(options?: any): AxiosPromise<GetTrialResponse> {
            return localVarFp.getTrial(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrialsApi - object-oriented interface
 * @export
 * @class TrialsApi
 * @extends {BaseAPI}
 */
export class TrialsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialsApi
     */
    public getTrial(options?: AxiosRequestConfig) {
        return TrialsApiFp(this.configuration).getTrial(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/optin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {PutProfileRequest} putProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProfile: async (putProfileRequest: PutProfileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putProfileRequest' is not null or undefined
            assertParamExists('putProfile', 'putProfileRequest', putProfileRequest)
            const localVarPath = `/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOptin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOptin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {PutProfileRequest} putProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProfile(putProfileRequest: PutProfileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProfile(putProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: any): AxiosPromise<GetProfileResponse> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(options?: any): AxiosPromise<GetUserResponse> {
            return localVarFp.getUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptin(options?: any): AxiosPromise<object> {
            return localVarFp.putOptin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {PutProfileRequest} putProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProfile(putProfileRequest: PutProfileRequest, options?: any): AxiosPromise<object> {
            return localVarFp.putProfile(putProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getProfile(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public putOptin(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).putOptin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {PutProfileRequest} putProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public putProfile(putProfileRequest: PutProfileRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).putProfile(putProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



